var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSinging = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Concert-Sing--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Concert Sing Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5 0.39A1.22 1.22 0 0 0 3.73 0.05a1.24 1.24 0 0 0 -0.88 0.95l-0.38 1.7a0.26 0.26 0 0 1 -0.3 0.19A1.75 1.75 0 1 0 3.49 5l0.62 -2.76A0.25 0.25 0 0 1 4.29 2a0.24 0.24 0 0 1 0.24 0.07l0.66 0.69a0.75 0.75 0 0 0 1.09 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 12a6.19 6.19 0 0 1 -4.87 -1.19 0.25 0.25 0 0 0 -0.25 0 0.24 0.24 0 0 0 -0.15 0.19l-1.33 8.21a2.2 2.2 0 0 0 0.72 2 0.48 0.48 0 0 1 0.13 0.49l-0.33 1.37a0.75 0.75 0 0 0 0.73 0.93 0.76 0.76 0 0 0 0.73 -0.57l0.33 -1.37a0.5 0.5 0 0 1 0.37 -0.36 2.24 2.24 0 0 0 1.57 -1.45l2.6 -7.89a0.28 0.28 0 0 0 0 -0.25 0.3 0.3 0 0 0 -0.25 -0.11Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 4.25 7.78 1.91a0.49 0.49 0 0 0 0.44 -0.1 0.51 0.51 0 0 0 0.18 -0.42 4.7 4.7 0 0 0 -8.76 -2.13 0.51 0.51 0 0 0 0 0.45 0.5 0.5 0 0 0 0.36 0.29Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.72 7.91a0.47 0.47 0 0 0 -0.35 -0.29L9.6 5.71a0.49 0.49 0 0 0 -0.44 0.1 0.49 0.49 0 0 0 -0.16 0.42 4.69 4.69 0 0 0 8.7 2.13 0.48 0.48 0 0 0 0.02 -0.45Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.25 13.51 -2.75 -0.84a1.74 1.74 0 0 0 -1.75 0.44 1.76 1.76 0 0 0 -0.45 1.76l0.8 2.61a0.5 0.5 0 0 1 -0.34 0.63 2.5 2.5 0 1 0 3.12 1.67l-1.4 -4.62a0.26 0.26 0 0 1 0.07 -0.25 0.24 0.24 0 0 1 0.24 -0.06l1.88 0.57a1 1 0 0 0 1.25 -0.67 1 1 0 0 0 -0.67 -1.24Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSinging);
export default ForwardRef;